import React, { useState } from "react";
import "../styles/AddEvent.css";
import { FaTimes, FaPaperclip } from "react-icons/fa";

export default function AddEvent({ onClose, onSave }) {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    location: "",
    calendarType: "Task",
    clientName: "",
    sharedWith: "Only me",
    file: null,
  });

  const calendarOptions = [
    { value: "Task", label: "Task", className: "addevent-field-task" },
    {
      value: "Start Day",
      label: "Start Day",
      className: "addevent-field-startday",
    },
    {
      value: "Deadline",
      label: "Deadline",
      className: "addevent-field-deadline",
    },
    {
      value: "Meetings",
      label: "Meetings",
      className: "addevent-field-meeting",
    },
    { value: "Call", label: "Call", className: "addevent-field-call" },
    { value: "Email", label: "Email", className: "addevent-field-email" },
    { value: "Payment", label: "Payment", className: "addevent-field-payment" },
  ];

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSave = () => {
    // Combine startDate + startTime, endDate + endTime for event
    const start = `${formData.startDate}T${formData.startTime}`;
    const end = `${formData.endDate}T${formData.endTime}`;

    onSave({
      title: formData.title,
      start,
      end,
      calendarType: formData.calendarType,
      location: formData.location,
      description: formData.description,
      clientName: formData.clientName,
      sharedWith: formData.sharedWith,
      file: formData.file,
    });
  };

  return (
    <div className="addevent-overlay">
      <div className="addevent-modal">
        {/* Navbar */}
        <div className="addevent-header">
          <h3 className="addevent-title">Add Event</h3>
          <FaTimes className="addevent-close" onClick={onClose} />
        </div>

        {/* Form */}
        <div className="addevent-body">
          <label>Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Enter title"
          />

          <label>Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter description"
          />

          <div className="addevent-row">
            <div className="addevent-field">
              <label>Start Date</label>
              <input
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
              />
            </div>
            <div className="addevent-field">
              <label>Start Time</label>
              <input
                type="time"
                name="startTime"
                value={formData.startTime}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="addevent-row">
            <div className="addevent-field">
              <label>End Date</label>
              <input
                type="date"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
              />
            </div>
            <div className="addevent-field">
              <label>End Time</label>
              <input
                type="time"
                name="endTime"
                value={formData.endTime}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="addevent-row">
            <div className="addevent-field">
              <label>Location</label>
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder="Enter location"
              />
            </div>
            <div
              className={`addevent-field ${formData.calendarType
                .replace(" ", "")
                .toLowerCase()}`}
            >
              <label>Calendar Type</label>
              <select
                name="calendarType"
                value={formData.calendarType}
                onChange={handleChange}
              >
                {calendarOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <label>Client Name</label>
          <input
            type="text"
            name="clientName"
            value={formData.clientName}
            onChange={handleChange}
            placeholder="Enter client name"
          />

          <label>Shared With</label>
          <div className="addevent-radio">
            {["Only me", "All Team", "Specific Team/Member"].map((opt) => (
              <label key={opt}>
                <input
                  type="radio"
                  name="sharedWith"
                  value={opt}
                  checked={formData.sharedWith === opt}
                  onChange={handleChange}
                />{" "}
                {opt}
              </label>
            ))}
          </div>

          <div className="addevent-attach">
            <FaPaperclip />
            <input
              type="file"
              name="file"
              onChange={handleChange}
              style={{ display: "inline-block" }}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="addevent-footer">
          <button className="addevent-btn" onClick={handleSave}>
            + Add Event
          </button>
        </div>
      </div>
    </div>
  );
}
